import { Link } from 'react-router-dom';
import EmployeeTabs from './SubComponents/EmployeeTabs';
import ProviderTabs from './SubComponents/ProviderTabs';
import ContractorTabs from './SubComponents/ContractorTabs';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import {
    IcoCaretRight,
    IconCaretLeft, IconSideLogoL, IconSideLogoS
} from '../../../components/buttons/IconButtons';
import routes from "../../../Routes/routes";
import {USER_TYPE_NAME_MODEL} from "../../../enums/userTypeEnum";



const SideBar = ({ isMenuOpen, setIsMenuOpen }) => {
    const { t } = useTranslation();
    const { user  } = useSelector((state) => state.authenticatioauthennSlice);
    const userType = user?.data?.userType?.name;


    return (
        <div className={`sidebar ${isMenuOpen ? 'sidbOpen' : 'sidbClose'}`}>
            <div className='sideTabs'>
                    <div className='logo_sidebar mb-3'>
                        <Link to={routes.login}>
                            <Tooltip title={t('go_to_home').toUpperCase()} placement='right' disableInteractive>
                                <div>
                                    <IconSideLogoL className={`sideLogoL ${isMenuOpen ? '' : 'hiddenLogo'}`} />
                                    <IconSideLogoS className={`sideLogoS ${isMenuOpen ? 'hiddenLogo' : ''}`}/>
                                </div>
                            </Tooltip>
                        </Link>
                    </div>
                    <div className='Change_menu_style'>
                        <Tooltip title={t('expand_bar').toUpperCase()} placement='right'>
                            <IcoCaretRight className={`${isMenuOpen ? 'hiddenImg' : ''}`} aria-hidden='true' onClick={() => setIsMenuOpen(true)}/>
                        </Tooltip>
                        <Tooltip title={t('collapse_bar').toUpperCase()} placement='right'>
                            <IconCaretLeft className={`position-absolute i-sidetabs-26 ${isMenuOpen ? '' : 'hiddenImg'}`} aria-hidden='true' onClick={() => setIsMenuOpen(false)}/>
                        </Tooltip>
                    </div>
                <div className='border-bottom border-white'/>
                {userType === USER_TYPE_NAME_MODEL.EMPLOYEE && <EmployeeTabs isMenuOpen={isMenuOpen} />}
                {userType === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE && <ProviderTabs isMenuOpen={isMenuOpen} />}
                {userType === USER_TYPE_NAME_MODEL.CONTRACTOR_IN_CHARGE && <ContractorTabs isMenuOpen={isMenuOpen} />}

            </div>
        </div>
    );
};
export default SideBar;
